import {
    USER_LIST_RESPONCE,
    DELETE_USER_REDUX_STATE,
    EDIT_USER_STATUS_REDUX_STATE,
    EDIT_USER_SIGN_STATUS_REDUX_STATE

} from "./actionTypes";

const INIT_STATE = {
    usersList: []
};

/**
 * Reducer function for managing the state of users.
 * @param {Object} state - The current state of the users.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns The updated state based on the action type.
 */
const Users = (state = INIT_STATE, action) => {
    switch (action.type) {

        case USER_LIST_RESPONCE:
           
            state = {
                ...state,
                usersList: action.payload,
              }
              return state;
         case  DELETE_USER_REDUX_STATE:
                state = {
                    ...state,
                    usersList: {data : action.payload},
                  }
                    return state;
         case  EDIT_USER_STATUS_REDUX_STATE:
                 state = {
                        ...state,
                        usersList:  {data : action.payload},
                     }
                            return state;
        case  EDIT_USER_SIGN_STATUS_REDUX_STATE:
                state = {
                         ...state,
                         usersList:  {data : action.payload},
                    }
                          return state;
        default:
            return state;
    }
};


export default Users;